import { Info } from "lucide-react";

export const SAPPHIRE_MAINTENANCE_STORAGE_KEY = "sapphireMaintenanceViews";
const SAPPHIRE_MAINTENANCE_MAX_VIEWS = 3;

const getViews = () =>
  Number(localStorage.getItem(SAPPHIRE_MAINTENANCE_STORAGE_KEY)) || 0;

export const shouldShowSapphireMaintenance = () =>
  getViews() < SAPPHIRE_MAINTENANCE_MAX_VIEWS;

/** Counted when the notice is shown, not when it is dismissed, so each visit
    counts once regardless of how (or whether) the user closes it. */
export const recordSapphireMaintenanceView = () => {
  localStorage.setItem(
    SAPPHIRE_MAINTENANCE_STORAGE_KEY,
    String(getViews() + 1),
  );
};

const SapphireMaintenance = () => {
  return (
    <div className="flex flex-col items-center gap-3 text-center">
      <div className="bg-dark-primary-main/40 flex size-14 items-center justify-center rounded-full">
        <Info className="text-dark-primary-main size-6" />
      </div>

      <h2 className="text-dark-text-50 text-xl leading-snug font-semibold">
        Sapphire Card Under Maintenance
      </h2>

      <p className="text-dark-text-50 text-sm leading-relaxed">
        The Sapphire Card is currently undergoing maintenance for the next 24
        hours. During this period, your card balance may temporarily display as
        $0.00 and transactions may fail.
        <br />
        We apologise for the inconvenience and appreciate your patience while we
        work to restore normal service.
      </p>

      <a
        href="https://t.me/PAYG8_LTD"
        target="_blank"
        rel="noopener noreferrer"
        className="text-dark-text-400 bg-dark-primary-gradient mt-3 w-full rounded-xl py-3 text-sm font-semibold transition-opacity hover:opacity-90"
      >
        Contact Support
      </a>
    </div>
  );
};

export default SapphireMaintenance;
